import { IForecastAccuracyRepository } from '@/coreInfrastructureModule/interfaces/IForecastAccuracyRepository';
import { IForecastAccuracyRawData, ForecastAccuracyAdapter } from '../adapters/ForecastAccuracyAdapter';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { GET_FORECAST_ACCURACY_HISTORY_PERIOD } from '@/InventoryControlModule/constants/index';

/**
 * 内示正答率履歴取得ユースケース
 * @description APIからデータを取得し、生データとして返す（periodでのフィルタリングは行わない）
 */
export class GetForecastAccuracyHistoryUseCase {
  /**
   * コンストラクタ
   * @param repository - 内示正答率リポジトリ
   */
  constructor(private repository: IForecastAccuracyRepository) {}

  /**
   * 内示正答率生データを取得する
   * @param businessId - 取引ID
   * @returns 内示正答率生データ
   * @description APIから全期間のデータを取得し、フィルタリング前の生データを返す
   */
  async execute(businessId: string): Promise<INetworkResult<IForecastAccuracyRawData, IError>> {
    // 本日の年と月を取得
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月は0から始まるため、1を加える

    // APIに送るPeriodは12ヶ月分固定
    const networkResult = await this.repository.getForecastAccuracyHistory(businessId, year, month, GET_FORECAST_ACCURACY_HISTORY_PERIOD);

    switch (networkResult.status.type) {
      case 'success':
        // Adapterを使用して生データに変換
        const rawData = ForecastAccuracyAdapter.adaptToRawData(businessId, networkResult.status.data);

        return {
          status: {
            type: 'success',
            data: rawData,
          },
        };
      case 'error':
        return {
          status: {
            type: 'error',
            error: networkResult.status.error,
          },
        };
    }
  }
}
